import { BaseClient } from '@/api'
import request from '@/utils/request'

export class CompanyClient extends BaseClient {
  constructor(
  ) {
    super('companies')
  }

  async createWithUser(data: any, username:string): Promise<any> {
    return request({
      url: `/${this.path}/${username}`,
      method: 'post',
      data
    })
  }

  async rechargeDriver(companyId :number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${companyId}/drivers/recharge`,
      method: 'post',
      data
    })
  }

  async rechargeCard(companyId :number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${companyId}/cards/recharge`,
      method: 'post',
      data
    })
  }

  async transferToCompany(companyId :number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${companyId}/company/transfer`,
      method: 'post',
      data
    })
  }

  async transferToDriver(companyId :number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${companyId}/driver/transfer`,
      method: 'post',
      data
    })
  }

  async transferToCard(companyId :number, data: any): Promise<any> {
    return request({
      url: `/${this.path}/${companyId}/card/transfer`,
      method: 'post',
      data
    })
  }
}
